import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as enums from '../enums'

export const DOC = gql`
  fragment FragmentSpaceRecordHistoryLog on SpaceRecordHistoryLog {
    userId
    action
    timestamp
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSpaceRecordHistoryLogFragment,
  ents.extra.space.Record.History.Log
>({
  action: enums.action.TRANSFORMER,
  userId: transformers.PASS_THROUGH,
  timestamp: graphql.transformers.OUT.nonNull(
    graphql.transformers.AWS_SCALARS.datetime,
  ),
})
